import { action } from '@ember/object';
import { service } from '@ember/service';
import Component from '@glimmer/component';

import type { Service } from 'webapp-types';

import CommonUiIconComponent from 'webapp/components/common/ui-icon';
import GoalsProgressComponent from 'webapp/components/goals/progress';
import SubmitButtonComponent from 'webapp/components/submit-button';

import type Goal from 'webapp/models-custom/goal';

interface Args {
	model: Goal;
}

export default class MetricDetailsExploreGoalsItemComponent extends Component<Args> {
	@service('model-manager/goals') declare mmGoalsService: Service.ModelManager.Goals;
	@service('metric-details') declare metricDetailsService: Service.MetricDetails;

	get goalData() {
		return this.args.model.primaryDataModel;
	}

	get isError(): boolean {
		return !!this.goalData?.block?.statusObjectsErrors?.length;
	}

	@action
	view(): void {
		this.mmGoalsService.openGoalInsightsDrawer(this.args.model);
	}
	<template>
		<div class="goal-item {{this.goalData.currentProgressClass}}">
			<div class="header">
				<div class="goal-item__title">
					{{@model.title}}
				</div>
			</div>

			<div class="progress-row">
				<div class="data">
					{{#if this.isError}}
						<div class="module-box__error">
							<CommonUiIconComponent @name="AlertFill" @size="sm" />
							Unable to load
						</div>
					{{else if this.goalData}}
						<GoalsProgressComponent
							@model={{@model}}
							@goalData={{this.goalData}}
							@size="large"
						/>
					{{/if}}
				</div>
				{{! the goal opens in its own drawer }}
				{{#unless this.metricDetailsService.isMobileMode}}
					<div class="action">
						<SubmitButtonComponent
							@theme="blue-outlined"
							@text="View"
							@onTrigger={{this.view}}
						/>
					</div>
				{{/unless}}
			</div>
		</div>
	</template>
}
